<template>
<div id="app_forum">
  <Forum v-if="((($route.query.act && $route.query.act.toUpperCase() == 'SC' && $route.query.c) || ($route.query.c)) || ($route.query.act && $route.query.act.toUpperCase() == 'SF' && $route.query.f)) || $route.query.showforum" />
  <Thread v-else-if="($route.query.act && $route.query.act.toUpperCase() == 'ST' && $route.query.t) || $route.query.showtopic" />
  <MiscRatings v-else-if="$route.query.act && $route.query.act.toUpperCase() == 'RATE' && $route.query.id" />
  <MiscAwards v-else-if="$route.query.act && $route.query.act.toUpperCase() == 'AWARDS' && $route.query.id" />
  <DebugMembers v-else-if="$route.query.act && $route.query.act == 'DebugAvatars'" />
  <DebugEmoticons v-else-if="$route.query.act && $route.query.act == 'DebugEmoticons'" />
  <GetPM v-else-if="$route.query.act && $route.query.act == 'Msg' && $route.query.MSID" />
  <PMs v-else-if="$route.query.act && $route.query.act == 'Msg'" />
  <AllForums v-else />
</div>
</template>

<script>
import Forum from './components/Forum'
import AllForums from './components/AllForums'
import Thread from './components/Thread'
import DebugMembers from './components/DebugMembers'
import DebugEmoticons from './components/DebugEmoticons'
import MiscRatings from './components/MiscRatings'
import MiscAwards from './components/MiscAwards'
import PMs from './components/PMs'
import GetPM from './components/GetPM'

export default {
  components: {
    Forum,
    AllForums,
    Thread,
    DebugMembers,
    DebugEmoticons,
    MiscRatings,
    MiscAwards,
    PMs,
    GetPM
  }
}
</script>

<style lang="scss">
@import "./skin-blue.scss";
@import "./App.scss";
</style>
